// removed by extract-text-webpack-plugin
module.exports = {"btnLink":"btnLink__3A-43"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailEye/styles.scss
// module id = 2126
// module chunks = 1